const inputLabel= "#8B8E98";
const placeholder= "#8C8C8C";
const inputBackground = "#F5F9FF";

const inputStyles = {
    mui_label: {
        color: inputLabel,
        fontSize:"10px",
        fontWeight: 500,    
    },
    mui_input_sx: {
        borderRadius: '8px',
        '& .MuiInputBase-input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px white inset',
            borderRadius: '8px',
        },
        '& .MuiInputLabel-asterisk': {
            display: 'none',
        },
        "& .MuiOutlinedInput-root": {
            fontSize: "14px", 
            borderRadius: '8px',
            backgroundColor: inputBackground,
            '&.Mui-focused fieldset': {
                borderWidth: 2.5,
            }
        },
        "& .MuiInputBase-input": {
            fontSize: "14px",
            padding: "10px 15px",
            borderRadius: '8px',
            border: "none",
            fontFamily: 'Kanit',
            "&::placeholder": {
                fontSize: "14px",
                color: placeholder,
                opacity: '1'
            },
        },
        "& .MuiInputBase-root": { // Input Base Root Styling
            margin: 0,

            // Hide the underline and border on focus
            "&:before": {
                borderBottom: "none", // Hide the underline before focus
            },
            "&:after": {
                borderBottom: "none", // Hide the underline after focus
            },
            "&:hover:not(.Mui-disabled):before": {
                borderBottom: "none", // Hide underline on hover
            },
        },
    },
    mui_formHelperText: {
        // position: "absolute",
        // transform: "translateY(40px)",
        position: "static",
        transform: 'none',
        // '@media(max-width: 600px)': {
        //     position: "static",
        //     transform: 'none'
        // }
    }
}

export { inputStyles }